"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lastMigrationVersion = exports.migrations = void 0;
const migrateBgNames_1 = require("./migrateBgNames");
const migrateCharABC_1 = require("./migrateCharABC");
const migrateCharPos_1 = require("./migrateCharPos");
const migrateCleanUpCamera_1 = require("./migrateCleanUpCamera");
const migrateDialogCharacters_1 = require("./migrateDialogCharacters");
const migrateFixStepNavigation_1 = require("./migrateFixStepNavigation");
const migrateFixUnlinkedSteps_1 = require("./migrateFixUnlinkedSteps");
const migrateGestureAnimation_1 = require("./migrateGestureAnimation");
const migrateNewSchema_1 = require("./migrateNewSchema");
const migratePerStepBackgrounds_1 = require("./migratePerStepBackgrounds");
const migrateRevertCharPos_1 = require("./migrateRevertCharPos");
const migrateStepNavigation_1 = require("./migrateStepNavigation");
const migrateToTimelines_1 = require("./migrateToTimelines");
exports.migrations = {
    1: migrateStepNavigation_1.migrateStepNavigation,
    2: migrateDialogCharacters_1.migrateDialogCharacters,
    3: migratePerStepBackgrounds_1.migratePerStepBackgrounds,
    4: migrateFixStepNavigation_1.migrateFixStepNavigation,
    5: migrateCleanUpCamera_1.migrateCleanUpCamera,
    6: migrateNewSchema_1.migrateNewSchema,
    7: migrateCharABC_1.migrateCharABC,
    8: migrateCharPos_1.migrateCharPos,
    9: migrateRevertCharPos_1.migrateRevertCharPos,
    10: migrateFixUnlinkedSteps_1.migrateFixUnlinkedSteps,
    11: migrateBgNames_1.migrateBgNames,
    12: migrateGestureAnimation_1.migrateGestureAnimation,
    13: migrateToTimelines_1.migrateToTimelines,
};
const migrationVersions = Object.keys(exports.migrations).sort((a, b) => Number(a) - Number(b));
exports.lastMigrationVersion = Number(migrationVersions[migrationVersions.length - 1]);
//# sourceMappingURL=index.js.map